module.exports = __webpack_public_path__ + "media/images/ogp/drill_shpops/drill_shops_ogp-2e50e2276a6c2f9832dd8c35de0be73f.png";